import React, { useState, useRef, useEffect, useMemo } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { getEventIdFromPath } from "../utils/getEventId";

const navItems = [
  { label: "Dashboard", path: "/admin", value: "admin" },
  { label: "Events", path: "/events", value: "events" },
  { label: "Settings", path: "/settings", value: "settings" },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState();
  const [selectorStyle, setSelectorStyle] = useState({});
  const listRefs = useRef([]);
  const id = getEventIdFromPath(location.pathname);

  // Build event child items dynamically
  const eventChildItems = useMemo(() => {
    if (!id) return [];
    return [
      { label: "Photos", path: `/events/${id}/photos` },
      { label: "Setting", path: `/events/${id}/setting` },
    ];
  }, [id]);

  const isEventChild =
    location.pathname.startsWith("/events/") &&
    location.pathname !== "/events" &&
    id;

  const menuItems = isEventChild ? eventChildItems : navItems;

  // Highlight active index based on current path
  useEffect(() => {
    const foundIndex = menuItems.findIndex((item) => {
      const currentPath = location.pathname.toLowerCase();
      const basePath = item.path.toLowerCase();
      return (
        currentPath === basePath ||
        currentPath.startsWith(basePath + "/")
      );
    });

    if (foundIndex !== -1) {
      setActiveIndex(foundIndex);
    }
  }, [location.pathname, menuItems]);

  // Selector position
  useEffect(() => {
    if (listRefs.current[activeIndex]) {
      const el = listRefs.current[activeIndex];
      setSelectorStyle({
        top: el.offsetTop + "px",
        left: el.offsetLeft + "px",
        height: el.offsetHeight + "px",
        width: el.offsetWidth + "px",
      });
    }
  }, [activeIndex]);

  return (
    <div id="accordian">
      <ul className="show-dropdown main-navbar">
        {/* Back button if inside child page */}
        {isEventChild && (
          <li
            onClick={() => navigate("/events")}
            className="back-btn"
            style={{ padding: "10px", cursor: "pointer", fontWeight: "bold" }}
          >
            ← Back to Events
          </li>
        )}

        {/* Active selector */}
        <div className="selector-active" style={selectorStyle}>
          <div className="top"></div>
          <div className="bottom"></div>
        </div>

        {/* Menu Items */}
        {menuItems.map((item, index) => (
          <li
            key={item.path}
            className={activeIndex === index ? "active" : ""}
            ref={(el) => (listRefs.current[index] = el)}
            onClick={() => setActiveIndex(index)}
          >
            <NavLink to={item.path}>
              <i className={item.icon}></i>
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
